<template>
  <div class="container">
    <div class="inner bg-white mob-bg-contact">
      <div class="row mb-15">
        <div class="col-12">
          <h2 class="c-title">Contact Us</h2>
        </div>
      </div>
      <loading :active.sync="isLoading" :can-cancel="true"></loading>
      <flash-message class="myCustomClass"></flash-message>
      <div class="row">
        <div class="col-md-6">
          <form class="form" role="form" @submit.prevent="handleSubmit">
            <div class="form-group row">
              <label class="col-lg-3 col-form-label form-control-label mob-label">
                Name:
                <span class="asterisk">*</span>
              </label>
              <div class="col-lg-9 mob-input">
                <input
                  type="text"
                  v-model="user.firstName"
                  id="firstName"
                  name="firstName"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.user.firstName.$error }"
                  autocomplete="name"
                />
                <div
                  v-if="submitted && !$v.user.firstName.required"
                  class="invalid-feedback"
                >First Name is required</div>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-3 col-form-label form-control-label mob-label">Company:</label>
              <div class="col-lg-9 mob-input">
                <input
                  type="text"
                  v-model="user.Company"
                  id="company"
                  name="Company"
                  class="form-control"
                  autocomplete="organization"
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-3 col-form-label form-control-label mob-label">
                Email:
                <span class="asterisk">*</span>
              </label>
              <div class="col-lg-9 mob-input">
                <input
                  type="email"
                  v-model="user.email"
                  id="email"
                  name="email"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.user.email.$error }"
                  autocomplete="email"
                />
                <div v-if="submitted && $v.user.email.$error" class="invalid-feedback">
                  <span v-if="!$v.user.email.required">Email is required</span>
                  <span v-if="!$v.user.email.email">Email is invalid</span>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-3 col-form-label form-control-label mob-label">Phone:</label>
              <div class="col-lg-9 mob-input">
                <input
                  type="text"
                  v-model="user.phone"
                  id="phone"
                  name="phone"
                  class="form-control"
                  autocomplete="tel"
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-3 col-form-label form-control-label mob-label">
                Your message:
                <span class="asterisk">*</span>
              </label>
              <div class="col-lg-9 mob-input">
                <textarea
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  v-model="user.message"
                  name="message"
                  :class="{ 'is-invalid': submitted && $v.user.message.$error }"
                ></textarea>
                <div v-if="submitted && $v.user.message.$error" class="invalid-feedback">
                  <span v-if="!$v.user.message.required">Your message is required</span>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label
                class="col-lg-3 col-form-label form-control-label mob-label"
              >How would you prefer us to reply to you?:</label>
              <div class="col-lg-9 mob-input">
                <select class="form-control" size="0" v-model="user.prefer" name="prefer">
                  <option value="Email">Email</option>
                  <option value="Phone">Phone</option>
                </select>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-3 col-form-label form-control-label mob-label"></label>
              <div class="col-lg-9 mob">
                <button class="btn btn-green mb-15">Send Message</button>
                <p>
                  <span class="asterisk">*</span> Fields marked with an asterisk are required
                </p>
              </div>
            </div>
          </form>
        </div>

        <div class="col-md-6 office-details">
          <h2 class="m-office-h2">Our Office Details</h2>
          <p>
            The Onsite Safety Training Company website is part of
            <a
              href="http://www.hs-group.com"
              class="green"
            >The Health &amp; Safety Group Ltd</a>. You can contact our office directly by post, phone, fax or email:
          </p>
          <p>
            The Health &amp; Safety Group Ltd
            <br />Building 5
            <br />3rd Floor
            <br />566 Chiswick High Road
            <br />Chiswick
            <br />London
            <br />W4 5YF
          </p>
          <p>
            <span v-if="localTelNo">Phone: {{ localTelNo }}<br />(Monday to Friday, 9am to 5.30pm)<br /></span>
            <span v-if="faxNo">Fax: {{ faxNo }}</span>
          </p>
          <p>We recommend you contact us using the form on this page as direct email may get caught in our junk email filters.</p>
        </div>
      </div>
    </div>
    <div class="d-contact-page">
      <pageBottom></pageBottom>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
require('vue-flash-message/dist/vue-flash-message.min.css');
import Vuelidate from 'vuelidate';
import VueFlashMessage from 'vue-flash-message';
Vue.use(Vuelidate);
Vue.use(VueFlashMessage);
import ContactApi from "@/services/Contact";
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import pageBottom from "./pageBottom.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import GenericMixin from "@/assets/mixins/GenericMixin";
export default {
  name: "app",
  data() {
    return {
      isLoading: false,
      user: {
        firstName: "",
        Company: "",
        email: "",
        phone: "",
        message: "",
        prefer: "Email"
      },
      submitted: false
    };
  },
  mixins: [GenericMixin],
  validations: {
    user: {
      firstName: { required },
      email: { required, email },
      message: { required }
    }
  },
  components: {
    Loading,
    pageBottom
  },
  mounted() {
    // this.user = {"firstName":"rdgdfg","Company":"","email":"jijufrancis812@gmail.com","phone":"","message":"fds","prefer":"Email"};
    if (
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) &&
      this.$route.name == "contact"
    ) {
      $("#nav").show();
      $("#body").addClass("mob-bg");
    }
  },
  methods: {
    handleSubmit(e) {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.isLoading = true;
      ContactApi.contact(this.user)
        .then(response => {
          this.isLoading = false;
          this.flash("Thank you, we will get back to you soon.", "success", {
            timeout: 2000
          });
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 575px) {
  .mob-label {
    width: 35%;
  }
  .mob-input {
    width: 65%;
  }
  .mob-bg-contact {
    background: #ffffff;
    border: 1px solid #8f8f8c;
    border-radius: 8px;
    padding: 13px;
  }
  .m-office-h2 {
    font-size: 18px;
    color: black;
  }
  .c-title {
    color: black;
    font-size: 18px;
  }
  .mob {
    .btn-green {
      float: right;
      min-width: 64%;
    }
    p {
      float: right;
      width: 65%;
      font-size: 16px;
    }
  }
  .office-details p {
    font-size: 16px;
  }
}
</style>
